import { api } from "@/lib/api";

const g = (p, params) => api.get(`/governance${p}`, { params }).then((r) => r.data);
const post = (p, b) => api.post(`/governance${p}`, b).then((r) => r.data);
const put = (p, b) => api.put(`/governance${p}`, b).then((r) => r.data);

export const gov = {
  meta: () => g("/meta"),
  overview: () => g("/overview"),
  provider: () => g("/provider"),
  saveProvider: (b) => put("/provider", b),
  documents: () => g("/documents"),
  document: (id) => g(`/documents/${id}`),
  saveDocument: (id, b) => put(`/documents/${id}`, b),
  docTransition: (id, b) => post(`/documents/${id}/transition`, b),
  newVersion: (id) => post(`/documents/${id}/new-version`),
  organisations: () => g("/organisations"),
  agreement: (id) => g(`/agreements/${id}`),
  createAgreement: (b) => post("/agreements", b),
  saveAgreement: (id, b) => put(`/agreements/${id}`, b),
  agrTransition: (id, b) => post(`/agreements/${id}/transition`, b),
  uploadEvidence: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/governance/agreements/${id}/evidence`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  register: (kind) => g(`/registers/${kind}`),
  createRecord: (kind, b) => post(`/registers/${kind}`, b),
  saveRecord: (kind, id, b) => put(`/registers/${kind}/${id}`, b),
  dpia: () => g("/dpia"),
  createDpia: (b) => post("/dpia", b),
  saveDpia: (id, b) => put(`/dpia/${id}`, b),
  approveDpia: (id, b) => post(`/dpia/${id}/approve`, b),
  archiveDpia: (id) => post(`/dpia/${id}/archive`, { action: "archive" }),
  accounts: () => g("/accounts"),
  setTeam: (id, b) => put(`/accounts/teams/${id}`, b),
  setUser: (id, b) => put(`/accounts/users/${id}`, b),
  audit: (params) => g("/audit", params),
  verifyAudit: () => g("/audit/verify"),
  auditKeys: () => g("/audit/keys"),
  myAgreements: () => g("/my/agreements"),
  myDocuments: () => g("/my/documents"),
};

export async function downloadFile(path, filename) {
  const r = await api.get(`/governance${path}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
